import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MapPin } from 'lucide-react';

const API = '/api';

const GoogleMap = () => {
  const [mapUrl, setMapUrl] = useState('https://maps.app.goo.gl/ngrKLady8yHJcQLE9');
  const [address, setAddress] = useState('Salon Galo, Heilermannstrasse 6, 45139 Essen');
  const [embedUrl, setEmbedUrl] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      if (response.data.google_maps_url) {
        setMapUrl(response.data.google_maps_url);
      }
      if (response.data.salon_address) {
        setAddress(response.data.salon_address);
        // Create embed URL from address
        const encodedAddress = encodeURIComponent(response.data.salon_address);
        setEmbedUrl(`https://www.google.com/maps?q=${encodedAddress}&output=embed`);
      }
    } catch (error) {
      console.error('Failed to fetch settings', error);
    }
  };

  // Default embed URL for Heilermannstrasse 6, 45139 Essen
  const defaultEmbedUrl = 'https://www.google.com/maps?q=Heilermannstrasse+6,+45139+Essen,+Germany&output=embed';

  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm" data-testid="google-map">
      <div className="p-6 border-b border-slate-100">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
            <MapPin className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-slate-900">So finden Sie uns</h3>
            <p className="text-sm text-slate-600">{address}</p>
          </div>
        </div>
      </div>
      <div className="relative h-96">
        <iframe
          src={embedUrl || defaultEmbedUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Salon Galo Location"
        />
      </div>
      <div className="p-4 bg-slate-50">
        <a
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium text-sm"
        >
          In Google Maps öffnen
          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default GoogleMap;
